export class LocationMap {
    el;
    constructor(el) {
        this.el = el;
        const token = window.mainSiteData.mapboxAPIToken;
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const mbxClient = require('@mapbox/mapbox-sdk/services/static');
        const staticService = mbxClient({ accessToken: token });
        const request = staticService.getStaticImage({
            ownerId: 'romeodigital',
            styleId: 'cjj3u20xn3oop2spcr30azajx', //'ckzxin1ui000315o9x2usjle7', //,
            width: 910,
            height: 432,
            position: {
                coordinates: [Number(this.el.getAttribute('data-longitude')), Number(this.el.getAttribute('data-latitude'))],
                zoom: 14
            },
            overlays: [
                {
                    marker: {
                        coordinates: [Number(this.el.getAttribute('data-longitude')), Number(this.el.getAttribute('data-latitude'))],
                        url: this.el.getAttribute('data-marker')
                    }
                }
            ],
            attribution: false,
            logo: false
        });
        const staticImageUrl = request.url();
        const img = document.createElement('img');
        img.src = staticImageUrl;
        img.classList.add('object-cover', 'w-full', 'h-62', 'tablet-portrait:h-108');
        this.el.appendChild(img);
    }
}
